import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { notificationsActions } from './+state/notifications.actions';
import { NotificationContract } from './contracts/notification.contract';

@Injectable({ providedIn: 'root' })
export class NotificationsService {
  private readonly store = inject(Store);

  public pushNotification(notification: NotificationContract): void {
    this.store.dispatch(notificationsActions.showNotification({ notification: notification }));
  }

  public dismiss() {
    this.store.dispatch(notificationsActions.dismiss());
  }
}
